import { ENV } from "constant/app";
import capitalize from "lodash/capitalize";
import moment from "moment";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { ConnectedWsConnStatus } from "ui/ws-conn-status";

class Footer extends React.Component {
  static get displayName() {
    return "Footer";
  }

  render() {
    return (
      <footer className="main-footer">
        <Row>
          <Col sm={12} md={10}>
            <div className="footer-text-container">
              <div>{moment().year()} &copy; Vistar Media, Inc.</div>
              <div>
                {capitalize(ENV.APP_NAME)} v{ENV.COMMIT_VERSION}
              </div>
            </div>
          </Col>
          <Col sm={12} md={2}>
            <ConnectedWsConnStatus className="text-center" />
          </Col>
          <Col xs={12}>
            <div className="clearfix" />
          </Col>
        </Row>
      </footer>
    );
  }
}

export default Footer;
